import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import Header from '../Components/Header';
import Footer from '../Components/Footer';
// import ClipLoader from 'react-spinners/ClipLoader';
import { loginUser, isTokenExpired } from '../utils/authUtils';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Base_Url = process.env.REACT_APP_API_BASE_URL;
const Brand_details = process.env.REACT_APP_API_BRANDS;

const BrandView = () => {
    const { id } = useParams();
    const [brand, setBrand] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [activeTab, setActiveTab] = useState('about');
    const [contactForm, setContactForm] = useState({
        name: '',
        email: '',
        message: ''
    });



    useEffect(() => {
        const fetchBrandWithAuth = async () => {
            if (!id) {
                setError('Brand ID is required');
                setLoading(false);
                return;
            }

            setError(null);
            setLoading(true);

            try {
                let token = localStorage.getItem('jwt_token');

                if (!token) {
                    try {
                        await loginUser();
                        token = localStorage.getItem('jwt_token');
                    } catch (loginErr) {
                        console.warn('Login failed. Trying register...');
                        // await registerUser();
                        // token = localStorage.getItem('jwt_token');
                    }
                }

                if (token && isTokenExpired(token)) {
                    await loginUser();
                    token = localStorage.getItem('jwt_token');
                }

                const headers = { Authorization: `Bearer ${token}` };
                const response = await axios.get(`${Base_Url}/${Brand_details}/${id}`, { headers });
                console.log('response.data.result', response.data.result)
                if (response.data.status === 'success') {
                    setBrand(response.data.result);
                } else {
                    throw new Error('Failed to load brand data');
                }
            } catch (error) {
                if (error.response?.status === 401) {
                    try {
                        await loginUser();
                        const retryToken = localStorage.getItem('jwt_token');
                        const retryHeaders = { Authorization: `Bearer ${retryToken}` };
                        const retryResponse = await axios.get(`${Base_Url}/${Brand_details}/${id}`, { headers: retryHeaders });

                        if (retryResponse.data.status === 'success') {
                            setBrand(retryResponse.data.result);
                        } else {
                            setError('Failed to load brand data');
                        }
                    } catch (retryError) {
                        console.error('Final retry failed:', retryError);
                        setError('Authentication failed. Please reload.');
                    }
                } else {
                    console.error('Fetch error:', error);
                    setError(error.response?.data?.message || 'Failed to fetch brand information');
                }
            } finally {
                setLoading(false);
            }
        };

        fetchBrandWithAuth();
    }, [id]);


    const handleContactFormChange = (e) => {
        const { name, value } = e.target;
        setContactForm(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleContactFormSubmit = async (e) => {
        e.preventDefault();

        try {
            let token = localStorage.getItem('jwt_token');
            if (!token || isTokenExpired(token)) {
                await loginUser();
                token = localStorage.getItem('jwt_token');
            }

            const headers = { Authorization: `Bearer ${token}` };
            const payload = {
                ...contactForm,
                brandId: id
            };

            const response = await axios.post(`${Base_Url}/shopping/contact/public`, payload, { headers });

            if (response.data.status === 'success') {
                const message = response.data.result?.message || 'Message sent successfully.';
                toast.success(message);
                setContactForm({ name: '', email: '', message: '' });
            } else {
                throw new Error('Failed to send message');
            }
        } catch (error) {
            console.error('Form submission error:', error);
            toast.error(error.response?.data?.message || 'Failed to send message. Please try again.')
            setError(error.response?.data?.message || 'Failed to send message. Please try again.');
        }
    };


    const handleTabClick = (tab) => {
        setActiveTab(tab);
    };

    // Social media links - you can make these dynamic from brand data
    const socialLinks = [
        { icon: 'fa-brands fa-facebook-f', url: brand?.socialLinks?.facebook },
        { icon: 'fa-brands fa-x-twitter', url: brand?.socialLinks?.twitter },
        { icon: 'fa-brands fa-linkedin-in', url: brand?.socialLinks?.linkedin },
        { icon: 'fa-brands fa-pinterest-p', url: brand?.socialLinks?.pinterest },
        { icon: 'fa-brands fa-youtube', url: brand?.socialLinks?.youtube },
        { icon: 'fa-brands fa-instagram', url: brand?.socialLinks?.instagram },
        { icon: 'fa-brands fa-threads', url: brand?.socialLinks?.threads }
    ];

    if (loading) {
        return (
            <div className="accent-custom">
                <Header />
                <div className="container py-5">
                    <div className="row">
                        <div className="col-xl-4 col-lg-6 mb-4">
                            <Skeleton height={250} width={250} /> {/* Brand Logo */}
                        </div>
                        <div className="col-xl-8 col-lg-6">
                            <Skeleton height={30} width={`60%`} />
                            <Skeleton height={20} width={`40%`} style={{ marginTop: 10 }} />
                            <Skeleton height={20} width={`50%`} style={{ marginTop: 10 }} />
                            <Skeleton height={20} width={`30%`} style={{ marginTop: 10 }} />
                            <Skeleton height={20} width={`70%`} style={{ marginTop: 10 }} />
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        );
    }


    if (error || !brand) {
        return (
            <div className="accent-custom">
                <Header />
                <div className="container text-center pt-100 pb-100">
                    <h3>{error || 'Brand not found or failed to load.'}</h3>
                    <button
                        onClick={() => window.location.reload()}
                        className="btn btn-primary mt-3"
                    >
                        Try Again
                    </button>
                </div>
                <Footer />
            </div>
        );
    }

    return (
        <div className="accent-custom">
            <Header />
            <section className="tp-product-details-area">
                {/* Brand Details Top Section */}
                <div className="tp-product-details-top pt-50">
                    <div className="container bg-white pb-50">
                        <div className="row">
                            <div className="col-xl-4 col-lg-6">
                                <div className="brand_dtls_logo">
                                    <img
                                        src={brand.brandLogo || "/assets/img/brands/no_brand.png"}
                                        alt={`${brand.name} logo`}
                                        onError={(e) => {
                                            e.target.src = "/assets/img/brands/no_brand.png";
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="col-xl-8 col-lg-6">
                                <div className="tp-product-details-wrapper ms-0 p-3">
                                    <h3 className="tp-product-details-title">{brand.name}</h3>

                                    {/* Brand Information */}
                                    <div className="tp-product-details-query">
                                        {brand.address && (
                                            <div className="tp-product-details-query-item d-flex align-items-center pb-10">
                                                <span><i className="fa-solid fa-location-dot me-2" /></span>
                                                <p>{brand.address}</p>
                                            </div>
                                        )}

                                        {brand.brandUrl && (
                                            <div className="tp-product-details-query-item d-flex align-items-center pb-10">
                                                <span><i className="fa-solid fa-globe me-2" /></span>
                                                <a
                                                    href={brand.brandUrl}
                                                    // target="_blank"
                                                    // rel="noopener noreferrer"
                                                    className="text-decoration-none"
                                                >
                                                    {brand.brandUrl}
                                                </a>
                                            </div>
                                        )}

                                        {brand.phoneNumber && (
                                            <div className="tp-product-details-query-item d-flex align-items-center pb-10">
                                                <span><i className="fa-solid fa-phone me-2" /></span>
                                                <a href={`tel:${brand.phoneNumber}`} className="text-decoration-none">
                                                    {brand.phoneNumber}
                                                </a>
                                            </div>
                                        )}

                                        {brand.email && (
                                            <div className="tp-product-details-query-item d-flex align-items-center pb-10">
                                                <span><i className="fa-solid fa-at me-2" /></span>
                                                <a href={`mailto:${brand.email}`} className="text-decoration-none">
                                                    {brand.email}
                                                </a>
                                            </div>
                                        )}
                                    </div>

                                    {/* Social Media Links */}
                                    <div className="tp-product-details-social">
                                        {socialLinks
                                            .filter((social) => social.url) // Only include non-empty URLs
                                            .map((social, index) => (
                                                <a
                                                    key={index}
                                                    href={social.url}
                                                    // target="_blank"
                                                    // rel="noopener noreferrer"
                                                    aria-label={`Visit ${brand.name} on social media`}
                                                >
                                                    <i className={social.icon} />
                                                </a>
                                            ))
                                        }

                                    </div>

                                    {/* View Products Button */}
                                    <div className="tp-product-list-add-to-cart pt-15">
                                        <Link to={`/product/${brand._id}`} className="tp-product-list-add-to-cart-btn">
                                            View Products
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Brand Details Bottom Section with Tabs */}
                <div className="tp-product-details-bottom pb-50">
                    <div className="container bg-white">
                        <div className="row">
                            <div className="col-xl-12">
                                <div className="tp-product-details-tab-nav tp-tab">
                                    {/* Tab Navigation */}
                                    <nav>
                                        <div className="nav nav-tabs justify-content-center p-relative tp-product-tab" role="tablist">
                                            <button
                                                className={`nav-link ${activeTab === 'about' ? 'active' : ''}`}
                                                onClick={() => handleTabClick('about')}
                                                type="button"
                                                role="tab"
                                                aria-selected={activeTab === 'about'}
                                            >
                                                About
                                            </button>
                                            <button
                                                className={`nav-link ${activeTab === 'contact' ? 'active' : ''}`}
                                                onClick={() => handleTabClick('contact')}
                                                type="button"
                                                role="tab"
                                                aria-selected={activeTab === 'contact'}
                                            >
                                                Contact
                                            </button>
                                            <span className="tp-product-details-tab-line" />
                                        </div>
                                    </nav>

                                    {/* Tab Content */}
                                    <div className="tab-content">
                                        {/* About Tab */}
                                        {activeTab === 'about' && (
                                            <div className="tab-pane fade show active" role="tabpanel">
                                                <div className="tp-product-details-desc-wrapper">
                                                    <div className="row justify-content-center">
                                                        <div className="col-xl-10">
                                                            <div className="tp-product-details-desc-item pb-5">
                                                                <div className="row">
                                                                    <div className="col-lg-12">
                                                                        <div className="tp-product-details-desc-content pt-25">
                                                                            {brand.description && <p>{brand.description}</p>}
                                                                            {/* Optional: Brand video section */}
                                                                            {/* {brand.videoUrl && (
                                                                                <div className="mt-25">
                                                                                    <div className="videoWrapper">
                                                                                        <iframe
                                                                                            width={560}
                                                                                            height={315}
                                                                                            src={brand.videoUrl}
                                                                                            title={`${brand.name} video`}
                                                                                            frameBorder={0}
                                                                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                                                                            referrerPolicy="strict-origin-when-cross-origin"
                                                                                            allowFullScreen
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                            )} */}

                                                                            <div className="tp-product-list-add-to-cart pt-55 d-inline-flex w-100 justify-content-center">
                                                                                <a
                                                                                    href={`/product/${brand._id}`}
                                                                                    className="tp-product-details-review-btn"
                                                                                >
                                                                                    View Products
                                                                                </a>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        {/* Contact Tab */}
                                        {activeTab === 'contact' && (
                                            <div className="tab-pane fade show active" role="tabpanel">
                                                <div className="tp-product-details-review-wrapper pt-30 pb-30">
                                                    <div className="row">
                                                        <div className="col-lg-6">
                                                            <div className="tp-product-details-review-form mb-25">
                                                                <form onSubmit={handleContactFormSubmit}>
                                                                    <div className="tp-product-details-review-input-wrapper">
                                                                        <div className="tp-product-details-review-input-box">
                                                                            <div className="tp-product-details-review-input">
                                                                                <input
                                                                                    name="name"
                                                                                    id="name"
                                                                                    type="text"
                                                                                    value={contactForm.name}
                                                                                    onChange={handleContactFormChange}
                                                                                    required
                                                                                />
                                                                            </div>
                                                                            <div className="tp-product-details-review-input-title">
                                                                                <label htmlFor="name">Your Name</label>
                                                                            </div>
                                                                        </div>

                                                                        <div className="tp-product-details-review-input-box">
                                                                            <div className="tp-product-details-review-input">
                                                                                <input
                                                                                    name="email"
                                                                                    id="email"
                                                                                    type="email"
                                                                                    placeholder="example@mail.com"
                                                                                    value={contactForm.email}
                                                                                    onChange={handleContactFormChange}
                                                                                    required
                                                                                />
                                                                            </div>
                                                                            <div className="tp-product-details-review-input-title">
                                                                                <label htmlFor="email">Your Email</label>
                                                                            </div>
                                                                        </div>

                                                                        <div className="tp-product-details-review-input-box">
                                                                            <div className="tp-product-details-review-input">
                                                                                <textarea
                                                                                    id="message"
                                                                                    name="message"
                                                                                    placeholder="Write your message here..."
                                                                                    value={contactForm.message}
                                                                                    onChange={handleContactFormChange}
                                                                                    required
                                                                                />
                                                                            </div>
                                                                            <div className="tp-product-details-review-input-title">
                                                                                <label htmlFor="message">Your Message</label>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    <div className="tp-product-details-review-btn-wrapper">
                                                                        <button
                                                                            type="submit"
                                                                            className="tp-product-details-review-btn"
                                                                        >
                                                                            Submit
                                                                        </button>
                                                                    </div>
                                                                </form>
                                                            </div>
                                                        </div>

                                                        {/* Optional: Map section */}
                                                        <div className="col-lg-6">
                                                            <div className="brand-contact-info pt-25">
                                                                <h5>Get in Touch</h5>
                                                                <div className="contact-info-list">
                                                                    {brand.address && (
                                                                        <div className="contact-info-item mb-3">
                                                                            <i className="fa-solid fa-location-dot me-2"></i>
                                                                            <span>{brand.address}</span>
                                                                        </div>
                                                                    )}


                                                                    {brand.phoneNumber && (
                                                                        <div className="contact-info-item mb-3">
                                                                            <i className="fa-solid fa-phone me-2"></i>
                                                                            <a href={`tel:${brand.phoneNumber}`} className="text-decoration-none">
                                                                                {brand.phoneNumber}
                                                                            </a>
                                                                        </div>
                                                                    )}
                                                                    {brand.email && (
                                                                        <div className="contact-info-item mb-3">
                                                                            <i className="fa-solid fa-envelope me-2"></i>
                                                                            <a href={`mailto:${brand.email}`} className="text-decoration-none">
                                                                                {brand.email}
                                                                            </a>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <ToastContainer position="top-right" autoClose={3000} />

            <Footer />
        </div>
    );
};

export default BrandView;